import * as _ from 'lodash';
import apiService from '../service/apiService';
import logUtils from '../HelperMethods/LogUtils';
import { uploadFile } from '../service/uploadDownloadService';
import { getActionTypes } from '../HelperMethods/UtilityFunctions';

export const types = getActionTypes('commentReducer')([
  'COMMENTS_LOADING_START',
  'COMMENTS_LOADED_SUCCESSFULLY',
  'COMMENTS_LOADED_FAILED',
  'ADDING_COMMENT',
  'UPSERT_COMMENT',
  'COMMENT_ADDING_FAILED',
  'SET_TASK_ID_FOR_COMMENTS',
  'DELETE_COMMENT',
]);

export function setTaskIdForComments(taskId) {
  return {
    type: types.SET_TASK_ID_FOR_COMMENTS,
    taskId,
  };
}

export function getCommentsByTaskId(taskId) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.COMMENTS_LOADING_START });
      const response = await apiService.getCommentsByTaskId(taskId);
      const comments = _.get(response, 'data.getCommentsByTaskId', []);
      dispatch({ type: types.COMMENTS_LOADED_SUCCESSFULLY, comments });
    } catch (e) {
      dispatch({ type: types.COMMENTS_LOADED_FAILED });
      logUtils.logError(e, `Error loading comments`);
    }
  };
}

export function setNullComments() {
  return (dispatch) => {
    dispatch({ type: types.COMMENTS_LOADED_SUCCESSFULLY, comments: [] });
  };
}

function upsertCommentObject(comment) {
  return {
    type: types.UPSERT_COMMENT,
    comment,
  };
}

function deleteCommentObject(comment) {
  return {
    type: types.DELETE_COMMENT,
    comment,
  };
}

export function onCommentUpsertedFromSubscription(comment) {
  return (dispatch, getState) => {
    const {
      commentReducer: { taskIdForComments },
    } = getState();
    if (taskIdForComments && comment.taskId === taskIdForComments) {
      dispatch(upsertCommentObject(comment));
    }
  };
}

export function onCommentDeletedFromSubscription(comment) {
  return (dispatch, getState) => {
    const {
      commentReducer: { taskIdForComments },
    } = getState();
    if (taskIdForComments && comment.taskId === taskIdForComments) {
      dispatch(deleteCommentObject(comment));
    }
  };
}

export function upsertComment(commentObject) {
  return async (dispatch) => {
    dispatch({ type: types.ADDING_COMMENT });
    try {
      let { attachments = null } = commentObject;
      if (attachments?.length) {
        const attachmentsToUpload = attachments.filter((attachment) => attachment.file);
        const attachmentUploadedResponses = await Promise.all(
          attachmentsToUpload.map((attachment) => uploadFile(attachment))
        );
        attachments = [...attachments.filter((a) => !a.file), ...attachmentUploadedResponses];
      }
      const createCommentInput = { ...commentObject, attachments };
      let response;
      let comment;
      if (createCommentInput.id) {
        response = await apiService.updateComment(createCommentInput);
        comment = _.get(response, 'data.updateComment');
      } else {
        response = await apiService.createComment(createCommentInput);
        comment = _.get(response, 'data.createComment');
      }
      if (!comment) {
        throw new Error('Comment Not Created');
      }
      dispatch(upsertCommentObject(comment));
    } catch (e) {
      dispatch({ type: types.COMMENT_ADDING_FAILED });
      logUtils.logError(e, 'Comment Adding Failed');
      throw e;
    }
  };
}
